module.exports = __webpack_public_path__ + "img/processing.06b2483f.svg";